import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import { formatDate } from 'dashboard/lib/utils/formatters';
import {
  DocumentImageInconsistentTimestampDetection,
  DocumentPdfInconsistentTimestampDetection,
} from 'dashboard/models/check';
import {
  ABBR_DATE_FORMAT,
  DATE_AND_TIME_SECONDS_FORMAT,
  SHORT_FORM_DATE,
} from 'lib/constants/luxonFormats';

export const computeDocumentPdfInconsistentTimestampDetectionMetadata = (
  check: DocumentPdfInconsistentTimestampDetection | DocumentImageInconsistentTimestampDetection,
): CheckMetadata => {
  const { timestamps = [] } = check.metadata || {};

  const metadata = timestamps.flatMap(
    (timestamp: { filename?: string; 'created-date': string; 'modified-date': string }) => {
      const createdDate = timestamp['created-date'];
      const modifiedDate = timestamp['modified-date'];
      let displayDateFormat;
      if (
        formatDate(createdDate, ABBR_DATE_FORMAT) === formatDate(modifiedDate, ABBR_DATE_FORMAT)
      ) {
        displayDateFormat = DATE_AND_TIME_SECONDS_FORMAT;
      } else {
        displayDateFormat = SHORT_FORM_DATE;
      }

      return [
        {
          label: 'Filename',
          value: timestamp.filename || '-',
        },
        {
          label: 'Created at',
          value: formatDate(timestamp['created-date'], displayDateFormat) || '--',
        },
        {
          label: 'Modified at',
          value: formatDate(timestamp['modified-date'], displayDateFormat) || '--',
        },
      ];
    },
  );

  return {
    metadata: createSimpleCheckMetadataArray(metadata),
    hideIfVerificationPassed: true,
  };
};
